import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import { SiteConfigProvider } from "./contexts/SiteConfigContext";
import ErrorBoundary from "./components/ErrorBoundary";


function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter basename={__BASE_PATH__}>
            <AuthProvider>
              <SiteConfigProvider>
                <AppRoutes />
              </SiteConfigProvider>
            </AuthProvider>
          </BrowserRouter>
        </I18nextProvider>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
